import type { ReactNode } from 'react';

function LegalPageLayout({
  title,
  updatedAt,
  children,
}: {
  title: string;
  updatedAt?: string;
  children: ReactNode;
}) {
  return (
    <div className="booking-page">
      <div className="booking-container" style={{ maxWidth: 920 }}>
        <a href="/" style={{ display: 'inline-flex', marginBottom: 12 }} aria-label="Tinoo">
          <img src="/tinoo-portal-logo.png" alt="Tinoo" style={{ height: 32, width: 'auto' }} />
        </a>
        <h1>{title}</h1>
        {updatedAt ? <p style={{ marginTop: 0, color: '#64748b' }}>{updatedAt}</p> : null}
        <div style={{ lineHeight: 1.6 }}>{children}</div>
      </div>
    </div>
  );
}

export function WebPaymentLegalNoticePage() {
  const legalText = `Aviso Legal
Tinoo · tinoo.io
https://tinoo.io · contact@voltea.co
1. Titularidad
El presente sitio web https://tinoo.io (en adelante, "el Sitio") es titularidad de Digital Innstinct S.L., con domicilio social en C/ Pujades, 126, 08005 Barcelona, CIF: B67504670, correo electrónico: contact@voltea.co (en adelante, "Tinoo").
Digital Innstinct S.L. opera comercialmente bajo la marca Tinoo. El uso del Sitio atribuye la condición de Usuario e implica la aceptación íntegra de las presentes condiciones.
2. Objeto y ámbito de aplicación
El presente Aviso Legal regula el acceso y uso del Sitio web https://tinoo.io, así como los contenidos, productos y servicios ofrecidos a través del mismo, que incluyen soluciones tecnológicas de comunicación y gestión empresarial vía WhatsApp y otros canales digitales.
3. Condiciones de uso
El Usuario se compromete a:
Hacer un uso lícito del Sitio conforme a la legislación vigente y al presente Aviso Legal.
No realizar actividades que dañen, inutilicen o deterioren el Sitio o sus contenidos.
No introducir, almacenar o difundir contenidos ilícitos, dañosos o lesivos de derechos de terceros.
Declarar ser mayor de edad y tener capacidad legal suficiente para contratar.
El incumplimiento de cualquiera de las condiciones anteriores podrá dar lugar a la restricción o cancelación del acceso al Sitio.
4. Propiedad intelectual e industrial
Todos los contenidos del Sitio —incluyendo, sin limitación, textos, imágenes, gráficos, logotipos, iconos, software, nombres comerciales y marcas— son propiedad de Digital Innstinct S.L. o de terceros que han autorizado su uso, estando protegidos por la legislación española e internacional sobre propiedad intelectual e industrial.
Queda prohibida la reproducción, distribución, comunicación pública o transformación de dichos contenidos sin la autorización expresa y por escrito del titular. Cualquier uso comercial requiere autorización previa.
5. Responsabilidad y garantías
Tinoo no garantiza la disponibilidad, continuidad ni infalibilidad del Sitio, ni que los contenidos estén permanentemente actualizados. Tinoo excluye, hasta el límite permitido por la ley, cualquier responsabilidad por:
Daños derivados de interrupciones del servicio o fallos técnicos.
Errores u omisiones en los contenidos.
Actuaciones de terceros o contenidos de sitios web externos enlazados.
Transmisión de virus u otros elementos dañinos a través del Sitio.
6. Enlaces a terceros
El Sitio puede contener enlaces a sitios web de terceros. Tinoo no controla ni es responsable de los contenidos, políticas o prácticas de dichos sitios. Los enlaces se ofrecen únicamente a título informativo.
7. Modificaciones
Tinoo se reserva el derecho a modificar, suspender o cancelar el Sitio, así como el presente Aviso Legal, en cualquier momento y sin previo aviso. Las modificaciones entrarán en vigor desde su publicación en el Sitio.
8. Legislación aplicable y jurisdicción
El presente Aviso Legal se rige por la legislación española. Para la resolución de cualquier controversia, las partes se someten a los Juzgados y Tribunales de Barcelona, con renuncia expresa a cualquier otro fuero que pudiera corresponderles.
Asimismo, se informa de la existencia de la plataforma europea de resolución de litigios en línea: http://ec.europa.eu/odr
9. Contacto
Para cualquier consulta, incidencia o reclamación relacionada con el presente Aviso Legal:
Correo electrónico: contact@voltea.co
Dirección postal: C/ Pujades, 126, 08005 Barcelona
Teléfono: (+34) 676 97 74 78`;

  return (
    <LegalPageLayout title="Aviso Legal">
      <pre style={{ whiteSpace: 'pre-wrap', fontFamily: 'inherit' }}>{legalText}</pre>
    </LegalPageLayout>
  );
}

export function WebPaymentPrivacyPolicyPage() {
  const privacyText = `Política de Privacidad
Tinoo · tinoo.io
https://tinoo.io · contact@voltea.co
Última actualización: enero de 2025
1. Responsable del tratamiento
En cumplimiento del Reglamento (UE) 2016/679 del Parlamento Europeo (RGPD) y la Ley Orgánica 3/2018, de Protección de Datos Personales y garantía de los derechos digitales (LOPDGDD), le informamos que el responsable del tratamiento de sus datos personales es:
Identidad: Digital Innstinct S.L. (marca comercial: Tinoo)
Dirección postal: C/ Pujades, 126, 08005 Barcelona
CIF: B67504670
Teléfono: (+34) 676 97 74 78
Correo electrónico: contact@voltea.co
2. Datos personales que tratamos
En función de cómo interactúe con el Sitio y nuestros servicios, podemos tratar las siguientes categorías de datos:
Datos de navegación: dirección IP, cookies, datos de dispositivo y navegador.
Datos de contacto: nombre, apellidos, correo electrónico, teléfono y empresa, cuando nos contacta o solicita información.
Datos de registro y cuenta: credenciales de acceso, perfil de usuario y preferencias cuando se registra en la plataforma.
Datos de uso de la plataforma: historial de interacciones, conversaciones gestionadas a través de WhatsApp y otros canales, configuración de flujos y plantillas.
Datos de facturación: nombre fiscal, NIF/CIF y datos necesarios para la emisión de facturas, cuando contrata nuestros servicios.
3. Finalidad y base jurídica del tratamiento
Tratamos sus datos con las siguientes finalidades y bases jurídicas:
Prestación del servicio contratado: gestión de su cuenta, acceso a la plataforma y soporte técnico. Base jurídica: ejecución de contrato (art. 6.1.b RGPD).
Respuesta a consultas e información precontractual: atención de solicitudes de información o demo. Base jurídica: interés legítimo y/o consentimiento (art. 6.1.a y 6.1.f RGPD).
Envío de comunicaciones comerciales y newsletters: con su consentimiento previo. Base jurídica: consentimiento (art. 6.1.a RGPD).
Análisis y mejora del Sitio: mediante cookies analíticas (con consentimiento previo). Base jurídica: consentimiento (art. 6.1.a RGPD).
Cumplimiento de obligaciones legales: emisión de facturas, conservación de registros. Base jurídica: obligación legal (art. 6.1.c RGPD).
4. Conservación de los datos
Los datos se conservarán mientras sea necesario para la finalidad para la que fueron recogidos y, en todo caso, durante los plazos legalmente exigidos:
Datos de clientes: durante la vigencia del contrato y hasta 6 años después (obligaciones mercantiles y fiscales).
Datos de comunicaciones comerciales: hasta que retire su consentimiento.
Datos de navegación y cookies: según se indica en la Política de Cookies.
Una vez cumplidos los plazos, los datos se suprimirán o anonimizarán de forma segura.
5. Destinatarios y transferencias internacionales
Digital Innstinct S.L. no venderá ni cederá sus datos personales a terceros, salvo en los casos siguientes:
Proveedores de servicios que actúan como encargados del tratamiento (servicios de hosting, cloud, herramientas de análisis, plataformas de mensajería), con los que se han suscrito los correspondientes contratos de encargo del tratamiento.
Meta Platforms, Inc.: en el contexto de la integración con WhatsApp Business API. Meta actúa como responsable independiente respecto a los datos que trata en su infraestructura. Dichas transferencias a EE. UU. quedan amparadas por las Cláusulas Contractuales Tipo aprobadas por la Comisión Europea.
Administraciones públicas y organismos con competencia legal, cuando sea legalmente exigible.
En ningún caso se realizarán transferencias internacionales fuera del Espacio Económico Europeo sin las garantías adecuadas exigidas por el RGPD.
6. Derechos de los interesados
Puede ejercitar en cualquier momento los siguientes derechos, dirigiéndose por escrito a contact@voltea.co adjuntando copia de su DNI o documento identificativo equivalente:
Acceso: conocer qué datos personales tratamos sobre usted.
Rectificación: corregir datos inexactos o incompletos.
Supresión: solicitar la eliminación de sus datos cuando ya no sean necesarios.
Oposición: oponerse al tratamiento en determinadas circunstancias.
Limitación: solicitar la restricción del tratamiento.
Portabilidad: recibir sus datos en formato estructurado y de uso común.
Retirada del consentimiento: en cualquier momento, sin que ello afecte a la licitud del tratamiento previo.
Asimismo, tiene derecho a presentar una reclamación ante la Agencia Española de Protección de Datos (www.aepd.es) si considera que el tratamiento no se ajusta a la normativa vigente.
7. Seguridad
Digital Innstinct S.L. aplica las medidas técnicas y organizativas adecuadas para garantizar la seguridad de sus datos personales y evitar su pérdida, alteración, acceso no autorizado o tratamiento ilícito, de acuerdo con el nivel de riesgo del tratamiento.
8. Cambios en la política
Esta Política de Privacidad puede ser actualizada para adaptarse a cambios legislativos o de nuestros servicios. Publicaremos la versión actualizada en https://tinoo.io con indicación de la fecha de última actualización. Le recomendamos revisarla periódicamente.
9. Contacto
Para cualquier consulta relativa a esta política o al tratamiento de sus datos:
Correo electrónico: contact@voltea.co
Dirección postal: C/ Pujades, 126, 08005 Barcelona`;

  return (
    <LegalPageLayout title="Política de Privacidad">
      <pre style={{ whiteSpace: 'pre-wrap', fontFamily: 'inherit' }}>{privacyText}</pre>
      <section id="eliminacion-de-datos" style={{ marginTop: 24 }}>
        <h2>Eliminación de datos</h2>
        <p>
          En Tinoo (operado por Digital Innstinct S.L.) respetamos tu derecho a controlar tus datos
          personales. Puedes solicitar la eliminación de todos los datos que hemos recopilado sobre
          ti, incluyendo los derivados de tu conexión mediante Meta / Facebook.
        </p>
        <p>
          <strong>¿Cómo solicitarlo?</strong>
        </p>
        <p>
          Envía un email a contact@voltea.co con el asunto "Solicitud de eliminación de datos"
          indicando el email o número de teléfono asociado a tu cuenta. Adjunta una copia de tu
          documento de identidad para verificar tu titularidad. Responderemos en un plazo máximo de
          30 días.
        </p>
        <p>
          <strong>¿Qué datos eliminamos?</strong>
        </p>
        <p>
          Nombre, email y datos de perfil, número de teléfono de WhatsApp, historial de
          conversaciones, configuración de flujos y plantillas, datos de navegación y sesiones, y
          datos de facturación una vez cumplidos los plazos legales.
        </p>
        <p>
          <strong>Datos que no podemos eliminar inmediatamente</strong>
        </p>
        <p>
          Por obligación legal conservamos durante los plazos exigidos: datos de facturación hasta 6
          años (Ley General Tributaria), y registros de comunicaciones hasta 12 meses (LSSI).
          Transcurridos dichos plazos, se eliminan de forma definitiva.
        </p>
        <p>
          <strong>Datos procedentes de Meta / Facebook</strong>
        </p>
        <p>
          Si conectaste tu cuenta mediante Facebook Login o vinculaste un número de WhatsApp
          Business, parte de tus datos pueden estar también en los sistemas de Meta Platforms, Inc.
          La eliminación en Tinoo no implica la eliminación automática en Meta. Para ello puedes
          hacerlo directamente en:{' '}
          <a
            href="https://www.facebook.com/help/contact/540977946302970"
            target="_blank"
            rel="noreferrer"
          >
            https://www.facebook.com/help/contact/540977946302970
          </a>
          .
        </p>
      </section>
    </LegalPageLayout>
  );
}

export function WebPaymentCookiesPolicyPage() {
  const cookiesText = `Política de Cookies
Tinoo · tinoo.io
https://tinoo.io · contact@voltea.co
Última actualización: enero de 2025
1. ¿Qué son las cookies?
Una cookie es un pequeño fichero de texto que un sitio web deposita en el navegador del usuario cuando este lo visita. Las cookies permiten al sitio recordar sus preferencias, analizar el comportamiento de navegación y, en algunos casos, mostrar contenido personalizado.
2. ¿Quién es el responsable?
El responsable de las cookies propias instaladas en https://tinoo.io es Digital Innstinct S.L. (marca Tinoo), con domicilio en C/ Pujades, 126, 08005 Barcelona y correo electrónico contact@voltea.co.
3. Tipos de cookies que utilizamos
3.1 Cookies técnicas (necesarias)
Son imprescindibles para el funcionamiento del Sitio. Permiten la navegación y el uso de las funciones básicas, como el acceso a áreas seguras o la gestión de la sesión. No requieren consentimiento.
3.2 Cookies analíticas
Nos permiten contabilizar las visitas y analizar el comportamiento de los usuarios para mejorar el Sitio. Utilizamos Google Analytics (Google LLC), que puede realizar transferencias internacionales a EE. UU. amparadas en Cláusulas Contractuales Tipo. Requieren su consentimiento previo.
3.3 Cookies de preferencias
Recuerdan sus elecciones (como el idioma o la región) para personalizar su experiencia. Requieren su consentimiento previo.
3.4 Cookies de marketing o publicidad (si aplica)
Se utilizan para mostrarle anuncios relevantes en función de su perfil de navegación. En caso de usarse, se informará en el panel de gestión de cookies. Requieren su consentimiento previo.
4. Tabla de cookies
A continuación se detallan las principales cookies instaladas por este Sitio:
_ga / _gid / _gat (Google Analytics): cookies analíticas. Duración: hasta 2 años. Proveedor: Google LLC.
cookieconsent_status: recuerda su preferencia sobre el uso de cookies. Duración: 1 año. Proveedor: propio.
session_id / PHPSESSID: gestión de sesión de usuario. Duración: sesión. Proveedor: propio.
Esta tabla puede actualizarse para reflejar cambios en las cookies utilizadas.
5. Cómo gestionar o rechazar las cookies
Puede gestionar sus preferencias de cookies de las siguientes formas:
Panel de cookies del Sitio: al acceder por primera vez a https://tinoo.io, se le presentará un banner que le permite aceptar, rechazar o configurar las cookies no esenciales. Puede modificar sus preferencias en cualquier momento desde el enlace "Gestionar cookies" en el pie de página.
Configuración del navegador: puede eliminar o bloquear cookies directamente desde la configuración de su navegador. Tenga en cuenta que la desactivación de ciertas cookies puede afectar a la funcionalidad del Sitio.
Guías de configuración por navegador:
Chrome: https://support.google.com/chrome/answer/95647
Firefox: https://support.mozilla.org/es/kb/habilitar-y-deshabilitar-cookies
Safari: https://support.apple.com/es-es/guide/safari/sfri11471/mac
Edge: https://support.microsoft.com/es-es/microsoft-edge/eliminar-las-cookies-en-microsoft-edge
6. Cookies de terceros
Algunos servicios integrados en el Sitio (como Google Analytics) pueden instalar sus propias cookies. Dichos terceros actúan como responsables independientes del tratamiento de los datos recogidos a través de sus cookies. Le recomendamos consultar sus políticas de privacidad.
7. Actualización de esta política
Esta Política de Cookies puede modificarse para adaptarse a cambios normativos o en el uso de cookies. La versión actualizada estará disponible en https://tinoo.io/politica-de-cookies con indicación de la fecha de revisión.
8. Más información
Para cualquier duda sobre el uso de cookies o el tratamiento de sus datos, puede contactarnos en contact@voltea.co o consultar nuestra Política de Privacidad.`;

  return (
    <LegalPageLayout title="Política de Cookies">
      <pre style={{ whiteSpace: 'pre-wrap', fontFamily: 'inherit' }}>{cookiesText}</pre>
    </LegalPageLayout>
  );
}
